export function sessionStart() {
    sessionStorage.setItem('__session_active__', 'true');
}

export function sessionDestroy() {
    sessionStorage.clear();
}

export function sessionExists() {
    return sessionStorage.getItem('__session_active__') === 'true';
}

export function sessionSet(key, value) {
    sessionStorage.setItem(key, value);
}

export function sessionGet(key) {
    return sessionStorage.getItem(key);
}
